var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('edit-base-piscine',{ref:"baseEdit",attrs:{"title":"Information de la page","width":"900"}},[_c('edit-base-seo',{attrs:{"pageContent":_vm.piscine.content}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }